// I-589 form completion card. Reads matter.workspace.i589 (loose shape).
// Shows progress bar, last reviewer, flag count, and a "Generate I-589"
// CTA. Empty state when the matter has no i589 data (real Mongo case
// without seeded workspace).

import type { I589Shape } from "../workspace-shapes";

interface Props {
  i589: I589Shape | undefined;
}

export function I589Card({ i589 }: Props) {
  const pct = i589?.sectionsComplete != null ? Math.round(i589.sectionsComplete * 100) : null;
  const flags = i589?.flags ?? 0;

  return (
    <div className="cc-card">
      <div className="cc-card-head">
        <div className="cc-card-title">I-589 Application</div>
        <div className="cc-card-sub">· Form completion</div>
      </div>
      <div style={{ padding: "14px 18px 16px" }}>
        {pct == null ? (
          <div style={{ fontSize: 12.5, color: "var(--muted)", marginBottom: 12 }}>
            No I-589 data yet — start drafting to populate this card.
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "space-between",
                marginBottom: 6,
              }}
            >
              <span
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  color: "var(--muted)",
                }}
              >
                Sections complete
              </span>
              <span
                style={{
                  fontVariantNumeric: "tabular-nums",
                  fontSize: 16,
                  fontWeight: 700,
                  color: pct >= 95 ? "var(--ok-600)" : "var(--ink)",
                }}
              >
                {pct}%
              </span>
            </div>
            <div
              style={{
                height: 6,
                borderRadius: 999,
                background: "var(--line-2)",
                overflow: "hidden",
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${pct}%`,
                  background: "var(--pa-accent, var(--muted))",
                  transition: "width 0.3s ease",
                }}
              />
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 10,
                marginBottom: 12,
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: 9.5,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    color: "var(--muted)",
                  }}
                >
                  Last reviewer
                </div>
                <div style={{ fontSize: 12.5, fontWeight: 600 }}>{i589?.lastReviewedBy ?? "—"}</div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: 9.5,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    color: "var(--muted)",
                  }}
                >
                  Open flags
                </div>
                <div
                  style={{
                    fontSize: 12.5,
                    fontWeight: 600,
                    color: flags > 0 ? "var(--red-600)" : "var(--ok-600)",
                  }}
                >
                  {flags}
                </div>
              </div>
            </div>
          </>
        )}
        <button
          style={{
            width: "100%",
            padding: "8px 12px",
            borderRadius: 6,
            background: "var(--pa-accent-strong, var(--muted))",
            color: "#fff",
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          {pct == null ? "Start I-589 →" : "Generate I-589 →"}
        </button>
      </div>
    </div>
  );
}
